module.exports = __webpack_public_path__ + "img/image17@3x.157a3a4a.png";